import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const fontCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([type=xs-bold-uppercase]){font-family:Open Sans;font-size:.625rem;font-weight:700;letter-spacing:.03em;line-height:.75rem;text-transform:uppercase}";
const WuiFontStyle0 = fontCss;

const WuiFont$1 = /*@__PURE__*/ proxyCustomElement(class WuiFont extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.type = undefined;
    }
    render() {
        return (h(Host, { key: '4e1ef97295d11913f52663c1c6563fe3ceb6e3e7' }, h("slot", { key: 'a20a12094f3615bea78bc504937c506d32a93aaa' })));
    }
    static get style() { return WuiFontStyle0; }
}, [1, "wui-font", {
        "type": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-font"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-font":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiFont$1);
            }
            break;
    } });
}
defineCustomElement$1();

const WuiFont = WuiFont$1;
const defineCustomElement = defineCustomElement$1;

export { WuiFont, defineCustomElement };

//# sourceMappingURL=wui-font.js.map